import React, { useEffect, useState, useRef } from "react"
import { Helmet } from "react-helmet"
import Layout from "@Components/layout"
import { Link } from "@StarberryUtils"
import axios from "axios"
import { graphql } from "gatsby"
import GoogleReview from "../images/google-reviews-color.png"
import { Container, Row, Col } from "react-bootstrap"
import { uknumberformatFront } from "@Components/common/common-functions"
import wordsToNumbers from "words-to-numbers"
import ReactMarkdown from "react-markdown"
import VideoModal from "@Components/Play/VideoModal"
import ImageRenderer from "../Components/ImageRenderer/ImageRenderer"
import ContactForm from "@Components/forms/general-enquiry"
import SEO from "@Components/seo"
import { useLocation } from "@reach/router"

import loadable from "@loadable/component"
import Banner from "@Components/Home/Banner/Banner"
import FeaturedPropery from "@Components/PropertyDetails/OfficePropery/OfficePropery"
import TeamSlider from "@Components/Static/TeamSlider/TeamSlider"
import ReviewSlider from "@Components/Static/ReviewSlider/ReviewSlider"

const FAQModule = loadable(() => import("@Components/FAQModule/FAQModule"))

const ContentImageBlock = loadable(() => import("@Components/ContentImageBlock/ContentImageBlock"))
const ContactModule = loadable(() => import("@Components/ContactBlock/ContactBlock"))

const OfficeDetails = (props) => {
  const office = props.data.glstrapi.office
  const isContactForm = props.pageContext.contactForm
  const isContactformPage = props.pageContext.isContactformPage

  const location = useLocation()
  const currentPath = location.pathname.replace(/\/+$/, "")
  const contactPath = `${currentPath}/contact`

  const [testimonials, setTestimonials] = useState([])
  const [isClient, setClient] = useState(false)

  const strapiconfig = {
    headers: {
      Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
    },
  }

  const getitems = async (url) => {
    try {
      const { data } = await axios.get(url, strapiconfig)
      setTestimonials(data)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    const url = `${process.env.GATSBY_STRAPI_SRC}/stb-google-reviews/google-review-reviews`
    getitems(url)
    setClient(true)
  }, [])

  const testimonial_count = testimonials ? testimonials.length : 0
  let rating_count = 0

  testimonials &&
    testimonials.length > 0 &&
    testimonials.map((item) => {
      rating_count += parseInt(wordsToNumbers(item.starRating))
    })

  const rating_avg = rating_count / testimonial_count

  let title = "Contact Bentley Hurst"

  if (!isContactformPage) {
    title = location.pathname.includes("contact-hale-estate-agents")
      ? "Contact Hale Estate Agents"
      : location.pathname.includes("contact-manchester-estate-agents")
      ? "Contact Manchester Estate Agents"
      : "Contact Bentley Hurst"
  }

  let desc

  if (location.pathname.endsWith("/contact/")) {
    desc =
      "Reach out to Bentley Hurst, Manchester and Hale's leading estate agency. We're here to help with your property needs - sales, lettings, valuations and more."
  } else {
    desc = office.Meta_Description
  }

  let metaTitle

  if (location.pathname.endsWith("/contact/")) {
    metaTitle = "Contact Bentley Hurst | Estate Agents in Manchester and Hale"
  } else {
    metaTitle = office ? office.Meta_Title : ""
  }

  const myRef = useRef(null)

  const executeScroll = () => {
    myRef.current.scrollIntoView()
  }
  
  return (
    <Layout
      css={isContactForm ? true : false}
      breadCrumPage={title}
      class="static"
      headerClass={isContactForm ? "white" : ""}
      breadCrumAlias={"contact"}
      type="contact"
    >
      <SEO
        title={metaTitle}
        description={desc}
        url={props.location.href}
      />

      <Helmet
        bodyAttributes={{
          class: "office-detail-template",
        }}
      />

      {office?.Slug === "manchester" && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@graph": [
                {
                  "@type": ["Organization", "RealEstateAgent"],
                  "@id": "https://www.bentleyhurst.co.uk/branches/manchester/#realestateagent",
                  "name": "Bentley Hurst - Estate Agents & Letting Agents in Manchester",
                  "url": "https://www.bentleyhurst.co.uk/branches/manchester/",
                  "description":
                    "Bentley Hurst Estate Agents in Manchester lead the way with cutting-edge property selling & letting services. When selling or renting your home, our Bentley Hurst Estate and Letting Agents aim to achieve your best sale price within a fitting timescale by harnessing professional photography, virtual tours & social media to elevate your property’s exposure.",
                  "logo": {
                    "@type": "ImageObject",
                    "url": "https://www.bentleyhurst.co.uk/images/mail-logo.png"
                  },
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "35B Whitworth Street West",
                    "addressLocality": "Manchester",
                    "postalCode": "M1 5ND",
                    "addressRegion": "Greater Manchester",
                    "addressCountry": "United Kingdom"
                  },
                  "sameAs": [
                    "https://www.facebook.com/BentleyHurstLTD",
                    "https://www.instagram.com/bentley.hurst/",
                    "https://www.youtube.com/channel/UCbok1WpAXT-I1586sYJRXbw",
                    "https://www.linkedin.com/company/bentley-hurst"
                  ],
                  "keywords": "estate agents in Manchester, lettings agents in Manchester"
                },
                {
                  "@type": "WebSite",
                  "@id": "https://www.bentleyhurst.co.uk/#website",
                  "name": "Bentley Hurst",
                  "url": "https://www.bentleyhurst.co.uk/",
                  "publisher": {
                    "@id": "https://www.bentleyhurst.co.uk/branches/manchester/#realestateagent"
                  }
                }
              ]
            })}
          </script>
        </Helmet>
      )}

      {office?.Slug === "hale" && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@graph": [
                {
                  "@type": ["Organization", "RealEstateAgent"],
                  "@id": "https://www.bentleyhurst.co.uk/branches/hale/#realestateagent",
                  "name": "Bentley Hurst Estate & Letting Agents - Hale",
                  "url": "https://www.bentleyhurst.co.uk/branches/hale/",
                  "description":
                    "Bentley Hurst are a new breed of estate agency in Hale. A modern, high end premium brand offering cutting edge and innovative technology to really make your property, whether that be for renting or selling, stand out from the crowd in the Hale and Cheshire market.",
                  "logo": {
                    "@type": "ImageObject",
                    "url": "https://www.bentleyhurst.co.uk/images/mail-logo.png"
                  },
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "162-164 Ashley Road",
                    "addressLocality": "Hale, Altrincham",
                    "postalCode": "WA15 9SF",
                    "addressRegion": "Greater Manchester",
                    "addressCountry": "United Kingdom"
                  },
                  "sameAs": [
                    "https://www.facebook.com/BentleyHurstLTD",
                    "https://www.instagram.com/bentleyhursthale/",
                    "https://www.youtube.com/channel/UCbok1WpAXT-I1586sYJRXbw",
                    "https://www.linkedin.com/company/bentley-hurst"
                  ],
                  "keywords": "estate agents in hale, lettings agents in hale"
                },
                {
                  "@type": "WebSite",
                  "@id": "https://www.bentleyhurst.co.uk/#website",
                  "name": "Bentley Hurst",
                  "url": "https://www.bentleyhurst.co.uk/",
                  "publisher": {
                    "@id": "https://www.bentleyhurst.co.uk/branches/hale/#realestateagent"
                  }
                }
              ]
            })}
          </script>
        </Helmet>
      )}

      {!isContactForm && office.Modules && office.Modules.length > 0
        ? office.Modules.map((Module, i) => (
            <div key={i}>
              {Module?.Banner_Title && (
                <Banner
                  executeScroll={executeScroll}
                  Pagename={office.Pagename}
                  Title={Module?.Banner_Title}
                  Video_Ask={Module?.Video_Ask}
                  Banner_Content={Module?.Banner_Content}
                  Banner_CTA_1_Label={Module?.Banner_CTA_1_Label}
                  Banner_CTA_1_URL={Module?.Banner_CTA_URL1}
                  Banner_CTA_2_Label={Module?.Banner_CTA_2_Label}
                  Banner_CTA_2_URL={Module?.Banner_CTA_URL2}
                  Banner_CTA2_Hash={Module?.Banner_CTA2_Hash}
                  Banner_Image={Module?.Banner_Image}
                  Right_Video_Image={Module?.Right_Video_Image}
                  Embed_Video_URL={Module?.Embed_Video_URL}
                  Show_Review={Module?.Show_Review}
                  Show_Search={Module?.Show_Search}
                  Slider={Module?.Slider}
                  Slide={Module?.Slide}
                  Show_Form={Module?.ShowForm}
                  ggfx_results={office.ggfx_results}
                  id={office.id}
                />
              )}

              {(Module?.Select_Collection === "Manchester_Sale_Properties" ||
                Module?.Select_Collection === "Manchester_Rent_Properties") && (
                <FeaturedPropery
                  Title={Module?.Title}
                  Content={Module?.Content}
                  Type={Module?.Select_Collection}
                  area="Manchester"
                />
              )}

              {(Module?.Select_Collection === "Hale_Sale_Properties" ||
                Module?.Select_Collection === "Hale_Rent_Properties") && (
                <FeaturedPropery
                  Title={Module?.Title}
                  Content={Module?.Content}
                  Type={Module?.Select_Collection}
                  area="Hale"
                />
              )}

              {Module?.__typename ===
                "GLSTRAPI_ComponentRevampImageContentBlock" && (
                <ContentImageBlock
                  {...Module}
                  ggfx_results={office.ggfx_results}
                  id={office.id}
                  ClassName={Module?.ClassName}
                  isModule="officedetail"
                  officeData={office}
                  executeScroll={executeScroll}
                />
              )}

              {Module?.Select_Collection === "Our_Teams" && (
                <TeamSlider
                  collection={Module?.Select_Collection}
                  Title={Module?.Title}
                  Content={Module?.Content}
                  officeTeam={office.Speak_with}
                />
              )}

              {Module?.__typename ===
                "GLSTRAPI_ComponentRevampContactBlock" && (
                <ContactModule {...Module} isModule="officedetail" officeData={office} />
              )}

              {Module?.Select_Collection === "Reviews" && (
                <ReviewSlider Title={Module?.Title} Content={Module?.Content} Name={office.Name} isPage={true} />
              )}

              {Module?.__typename == "GLSTRAPI_ComponentRevampFaqBlock" &&
                  <>
                  {Module?.FAQTitle==="Frequently Asked Questions About Estate Agents in Hale" ?
                  <FAQModule {...Module} />
                  :
                  <></>
                  }
                  </>
              }
            </div>
          ))
        : null
      }

      {isContactForm && (
        <div className="contact-page">
          <div className="contack-image">
            <ImageRenderer
              renderer="pic-src"
              ImageSrc={office.Image}
              altText={`${office.Name} - Bentley Hurst`}
              ggfx_results={office.ggfx_results}
              strapi_id={office.id}
              imagename="office.Image.bannerimg"
            />
          </div>

          <Container>
            <Row>
                <Col lg="7">
                  <div className="contact-detail d-lg-block padding-right">
                    <h1 className="contact-h1">Contact Us</h1>
                    <ContactForm
                      showVideo={true}
                      to_email_id={
                        isContactformPage
                          ? process.env.MAIL_TO
                          : office?.Email
                      }
                      isContactformpage={true}
                    />
                  </div>
                  {contactPath && (
                    <div className="office-address">
                      <Row>
                        {props.data.glstrapi?.offices.length > 0 && props.data.glstrapi?.offices?.map(item => {
                            let Path = item.Slug ? `/branches/${item.Slug}/` : '/';
                            return (
                                <Col md="6">
                                    <div className="office-details">
                                        <div className="rich-text-editer-block">
                                            <a href={Path} className="branch">{item?.Footer_Title}</a>
                                            <a href={item?.Address_Link} target="_blank" className="address"><ReactMarkdown source={item.Address} allowDangerousHtml /></a>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })}
                      </Row>
                    </div>
                  )}
                </Col>
            </Row>
          </Container>
        </div>
      )}
    </Layout>
  )
}

export default OfficeDetails

export const pageQuery = graphql`
  query OfficeQuery($id: ID!) {
    glstrapi {
      office(id: $id, publicationState: LIVE) {
        id
        Name
        Slug
        Email
        Phone
        Address_Link
        Address
        Meta_Title
        Meta_Description
        Opening_Hours
        Video_URL
        ggfx_results {
          transforms
          src_url
          src_cftle
        }
        Image {
          url
          alternativeText
        }
        Speak_with {
          Image {
            url
            alternativeText
          }
          Designation
          Name
          Phone
          Email
          URL
        }
        Modules {
          ... on GLSTRAPI_ComponentComponentBanner {
            Banner_CTA_1_Label
            Banner_CTA_2_Label
            Banner_CTA_URL1 {
              Alias
            }
            Banner_CTA_URL2 {
              Alias
            }
            Banner_Content
            Banner_Image {
              alternativeText
              url
              url_sharp {
                childImageSharp {
                  gatsbyImageData(
                    formats: AUTO
                    width: 1500
                    quality: 75
                    layout: FIXED
                    transformOptions: {
                      cropFocus: CENTER
                      fit: COVER
                    }
                  )
                }
              }
            }
            Banner_Title
            Embed_Video_URL
            Right_Video_Image {
              alternativeText
              url
            }
            Upload_Video {
              url
            }
            Show_Review
            Show_Search
            Show_Tags
            Video_Background_Image {
              url
              alternativeText
            }
            Video_Ask
            Slider {
              Slider_Image {
                alternativeText
                url
                url_sharp {
                  childImageSharp {
                    gatsbyImageData(formats: AUTO
                      width: 1400
                      quality: 75
                      layout: FIXED
                      transformOptions: {cropFocus: CENTER, fit: COVER}
                    )
                  }
                }
              }
              Show_Review
              Title
              Banner_Content
              Banner_CTA_2_Label
              Banner_CTA_1_Label
              Banner_CTA_1_URL {
                Alias
              }
              Banner_CTA_2_URL {
                Alias
              }
            }
            Slide
          }

          ... on GLSTRAPI_ComponentComponentCollections {
            id
            Content
            Select_Collection
            Title
            View_More {
              CTA_1_Label
              CTA_1_URL {
                Alias
              }
            }
          }

          ... on GLSTRAPI_ComponentRevampImageContentBlock {
            id
            __typename
            BackgroundColor
            TitleBlock: Title
            Content
            Spacing
            Image_Position
            Video_Link
            ClassName
            Image {
              url
              alternativeText
            }
            Ctas {
              Cta_Label
              Cta_URL {
                URL
                Secondary_URL
                Alias
              }
            }
          }
          ... on GLSTRAPI_ComponentRevampFaqBlock {
            __typename
            id
            Background
            FAQTitle: Title
            Content
            Ctas {
              Cta_Label
              Cta_URL {
                URL
                Secondary_URL
                Alias
              }
            }
            FAQ_List {
              Question
              Answer
            }
          }

          ... on GLSTRAPI_ComponentRevampContactBlock {
            __typename
            id
            ContactTitle: Title
            Content
            Ctas {
              Cta_Label
              Cta_URL {
                URL
                Secondary_URL
                Alias
              }
            }
            Offices {
              Name
              Phone
              Whatsapp
              Email
              latitude
              longitude
            }
          }
        }
      }
      offices {
        Name
        Address
        Address_Link
        Footer_Title
        Slug
      }
    }
  }
`